export default function isValidFunction(func?: any): func is Function {
  return typeof func === "function";
}
